import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { isTopLevelDomainFI } from './shared/util/deploy-helper';
import { RolesCondition } from './user/user';
import { UserService } from './user/user.service';

@Injectable({
  providedIn: 'root',
})
export class FinlandRouteGuard {
  constructor(private usersService: UserService) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        const { rolesCondition, enableCountries, rolesConditionFI } =
          route.data as {
            requiredRoles: string[];
            rolesCondition: RolesCondition;
            requiredFeatureFlag: string;
            enableCountries: string[];
            rolesConditionFI: string[];
          };

        if (
          isTopLevelDomainFI() &&
          enableCountries.includes('fi') &&
          rolesConditionFI
        ) {
          return resolve(
            this.usersService.checkAccess(rolesConditionFI, rolesCondition),
          );
        }
        return resolve(true);
      } catch (error) {
        reject(new Error(error));
      }
    });
  }
}
